<div class="wrapper" data-testid="sot-error">
  <div class="container">
    <div class="inline-icon" inlineSVG="sot/sot-icon.svg#sot-HypersoftLogo"></div>
  </div>
  <div class="container">
    <div class="text-container">
      <p>
        Leider ist ein Fehler aufgetreten, weshalb das SOT nicht gestartet werden konnte.
      </p>
      <p>
        Unfortunately an error occurred which is why the SOT could not be started.
      </p>
      <div class="svg-container">
        <svg class="checkmark red-checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <circle class="checkmark__circle red-checkmark__circle" cx="26" cy="26" r="25" fill="none" />
          <path class="checkmark__circle red-checkmark__check" fill="none" d="M16 16 36 36" />
          <path class="checkmark__circle red-checkmark__check" fill="none" d="M36 16 16 36" />
        </svg>
      </div>
      <div class="version">
        <p>
          Version: {{version}}
        </p>
      </div>
    </div>
  </div>
</div>